import useAxios from "axios-hooks";
import React from "react";
import QueryLoading from "../components/animations/QueryLoading";
import PurchaseList from "../components/purchasepage/PurchaseList";
import { API_URL } from "../config";

const PurchasePage = ({ userData, userLoading, refetchUser, match }) => {
  const [{ data: allCourses, loading: allCoursesLoading }] = useAxios({
    url: `${API_URL}/getAllCourses`,
    method: "GET",
    withCredentials: true,
  });
  if (userLoading || allCoursesLoading) return <QueryLoading />;
  console.log(allCourses);
  // Check if the user is logged in
  // If the user is logged in, no registration is required
  return <PurchaseList allCourses={allCourses} userData={userData} />;
};

export default PurchasePage;
